import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Select, Modal, message, Row, Col, Spin } from 'antd';
import { STATUS } from '@/constants/act-room';
import RangePicker from '@/form-component/range-picker';
import apis from '../../apis';
import { getLevelName, getLevelColorForTag } from '@/constants/index';
import { listenBabelMessage } from '@/common/utils/global-message';
import './index.less';
import { loginStateExpiress, formateTimeStamp } from '@/common/utils';
import env from '@/env';
import CommonCard from '../common-card';
import Container from '@/components/container';
import BabelCreateHuichang from '@/components/babel-create-huichang';
import { prefixCls } from '@/constants';

const { Option } = Select;
const BABEL_URL = env.BABEL_DOMAIN + '/active/babelCommon/index.html#/';

const ActivityOperate = () => {
  // 列表请求的入参
  const initalState = {
    keywords: null,
    startTime: null,
    endTime: null,
    status: null,
  };

  const [conditions, setConditions] = useState(initalState);

  const [data, setData] = useState({
    related: [],
    relevant: [],
    loading: '',
  });

  const [searchForm] = Form.useForm();
  const [createVisible, setCreateVisible] = useState(false);
  const [limitActivityVisiable, setLimitActivityVisiable] = useState(false);
  const [seletedCardId, setSeletedCardId] = useState('');
  const [limitProgramList, setLimitProgramList] = useState([]);

  // 新建项目 取消
  const handleCreateCancel = () => {
    setCreateVisible(false);
  };
  // 卡片 查看数据
  function toLookData(e, items) {
    e.preventDefault();
    const { id, name } = items;
    const targetUrl =
      BABEL_URL + 'dataCenterDetail/baseData?activityId=' + id + '&activityName=' + name + '&activeTab=baseData';
    window.open(targetUrl);
  }

  // 新建项目距成功回调
  useEffect(() => {
    return listenBabelMessage.babelCreateActivitySuccess((e) => {
      message.success('新建成功');
      setConditions({ ...conditions });
      setCreateVisible(false);
    });
  });

  // 新建项目距失败回调
  useEffect(() => {
    return listenBabelMessage.babelCreateActivityFail(() => {
      handleCreateCancel();
      message.error('系统异常，请稍后再试。');
    });
  });
  // 新建项目距取消回调
  useEffect(() => {
    return listenBabelMessage.babelCancelCreateActivity(() => {
      handleCreateCancel();
    });
  });
  // 新建项目未登录回调
  useEffect(() => {
    return listenBabelMessage.unlogin(() => {
      loginStateExpiress();
    });
  });
  // 请求主接口数据
  useEffect(() => {
    setData((data) => ({ ...data, loading: true }));
    apis
      .actRoomListReverse(conditions)
      .then((res) => {
        const {
          ret,
          data: { related, relevant },
        } = res;
        if (ret === '0') {
          setData({
            related: related,
            relevant: relevant,
            loading: false,
          });
        } else {
          setData((data) =>
            Object.assign({}, data, {
              list: [],
              loading: false,
            })
          );
        }
      })
      .catch((ex) => {
        setData((data) =>
          Object.assign({}, data, {
            list: [],
            loading: false,
          })
        );
      });
  }, [conditions]);

  function activityPlanListRelated(id) {
    const conditions = {
      currentPage: 1,
      pageSize: 50,
      towerId: id,
      module: 'room',
    };
    apis.activityPlanListRelated(conditions).then((res) => {
      if (res && res.ret === '0') {
        setLimitProgramList(res.data.list);
      }
    });
  }

  const onFinish = (values) => {
    const { activityTime, status, keywords } = values;
    let startTime, endTime;

    if (activityTime && activityTime.length > 0) {
      startTime = activityTime[0].valueOf();
      endTime = activityTime[1].valueOf();
    }
    setConditions({ ...conditions, startTime, endTime, status, keywords });
  };

  function toLinkActivity(e, id) {
    e.preventDefault();
    setLimitActivityVisiable(true);
    activityPlanListRelated(id);
    setSeletedCardId(id);
  }

  function toRelated(related, planCode, index) {
    if (related === 0) {
      correlate(planCode, index);
    } else {
      // relieve(planCode, index)
    }

    function correlate(planCode, index) {
      apis
        .actRoomCorrelate({ planCode, towerIds: seletedCardId })
        .then((res) => {
          if (res && res.ret === '0') {
            const list = Object.assign([], limitProgramList);
            list[index].related = 1;
            setLimitProgramList(list);
            message.success('关联成功');
          }
        })
        .catch((err) => {
          message.error('关联失败，请稍后重试');
          console.log(err);
        });
    }
  }

  function closeLimitPop() {
    setLimitActivityVisiable(false);
    setConditions({ ...conditions });
  }

  const formRowLayout = {
    justify: 'space-between',
    align: 'middle',
    gutter: 16,
  };
  return (
    <div className="my-create-operate-wrap">
      <div className="my-create-search filter-box-wrap">
        <Form form={searchForm} onFinish={onFinish}>
          <Row {...formRowLayout}>
            <Col span={6}>
              <Form.Item name="keywords" label="搜索">
                <Input maxLength={50} placeholder="项目ID/项目名称/创建人" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="activityTime" label="时间">
                <RangePicker
                  style={{ width: '100%' }}
                  format={['YYYY-MM-DD']}
                  className={prefixCls + '-picker-full-size'}
                  placeholder={['开始时间', '结束时间']}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="status" label="项目状态">
                <Select placeholder="全部" allowClear>
                  {STATUS.map((item) => (
                    <Option key={item.val} value={item.val}>
                      {item.title}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Row align="middle" justify="end">
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    clstag="pageclick|keycount|hclist_1603695042080|1"
                    style={{ marginRight: '20px' }}
                  >
                    查询
                  </Button>
                </Form.Item>
                <Form.Item>
                  <Button onClick={() => searchForm.resetFields()} type="submit">
                    重置
                  </Button>
                </Form.Item>
              </Row>
            </Col>
          </Row>
        </Form>
      </div>
      <Container bg={false} margin={{ left: false, right: false, top: true }}>
        <div className="my-create-list-wrap">
          <div className="my-create-header">
            <div className="my-create-header-title">我的通天塔项目</div>
            <div className="my-create-btn">
              {/* {
                (data.related.count > 0 || data.relevant.count > 0) ? <Button className='createAvenuProgram' size='small' type='primary' onClick={() => { setCreateVisible(true) }} clstag='pageclick|keycount|hclist_1603695042080|3'>+新建会场项目</Button> : null
              } */}
            </div>
          </div>
          {!data.loading ? (
            <>
              {data.related.count <= 0 && data.relevant.count <= 0 ? (
                <div className="my-create-empty">
                  <img
                    className="my-create-empty-img"
                    src="//img30.360buyimg.com/pop/jfs/t1/165430/10/8418/9659/603c5b74E2abb0672/1730e2f9ea510b0c.png"
                  />
                  {/* <div className='my-create-btn'>
                          <Button className='createAvenuProgram' size='small' type='primary' onClick={() => { setCreateVisible(true) }} clstag='pageclick|keycount|hclist_1603695042080|3'>+新建会场项目</Button>
                        </div> */}
                </div>
              ) : (
                <div className="my-create-card-wrap">
                  {data.related.count > 0 ? (
                    <>
                      <div className="my-create-card-wrap-title">我创建的({data.related.count})</div>
                      <div className="my-create-card-item-wrap">
                        {data.related.list.map((item) => (
                          <CommonCard
                            key={item.id}
                            item={item}
                            toLookData={toLookData}
                            toLinkActivity={toLinkActivity}
                          />
                        ))}
                      </div>
                    </>
                  ) : null}
                  {data.relevant.count > 0 ? (
                    <>
                      <div className="my-create-card-wrap-title">我参与的({data.relevant.count})</div>
                      <div className="my-create-card-item-wrap">
                        {data.relevant.list.map((item) => (
                          <CommonCard
                            key={item.id}
                            item={item}
                            toLookData={toLookData}
                            toLinkActivity={toLinkActivity}
                          />
                        ))}
                      </div>
                    </>
                  ) : null}
                </div>
              )}
            </>
          ) : (
            <div className="operate-spin">
              <Spin />
            </div>
          )}
        </div>
        <Modal
          className="modal-frame"
          visible={createVisible}
          footer={null}
          width={908}
          onCancel={handleCreateCancel}
          closable={false}
        >
          <BabelCreateHuichang />
        </Modal>
        <Modal visible={limitActivityVisiable} footer={null} width={908} title="关联营销活动" onCancel={closeLimitPop}>
          <div className="avenue-limit-activity-pop">
            {limitProgramList.length > 0 ? (
              limitProgramList.map((item, index) => (
                <div className="avenue-limit-activity-item" key={item.planCode}>
                  <div className="first-line-wrap">
                    <span
                      className="level"
                      style={{
                        backgroundColor: getLevelColorForTag(item.level),
                        color: 'white',
                      }}
                    >
                      {getLevelName(item.level, item.otherLevel)}
                    </span>
                    <span className="name">{item.activityName}</span>
                  </div>
                  <div className="second-line-wrap">
                    <span className="id">活动编号：{item.planCode}</span>
                    <span className="time">
                      活动时间：{formateTimeStamp(item.activityStartTime)}至{formateTimeStamp(item.activityEndTime)}
                    </span>
                  </div>
                  <div className="third-line-wrap">
                    <div className="category">
                      <span className="category-text">主推品类：{item.categoryName}</span>
                    </div>
                    {item.dailySales ? <div className="day-price">预估日销售额：{item.dailySales}</div> : null}
                    {item.shareErp ? <div className="share-erp">权限分享人：{item.shareErp}</div> : null}
                  </div>
                  <div
                    className={item.related === 1 ? 'related YES' : 'related'}
                    onClick={() => toRelated(item.related, item.planCode, index)}
                  >
                    {item.related === 0 ? '关联' : '已关联'}
                  </div>
                </div>
              ))
            ) : (
              <div className="limit-empty-wrap">
                <img
                  className="limit-empty-img"
                  src="//img30.360buyimg.com/pop/jfs/t1/165430/10/8418/9659/603c5b74E2abb0672/1730e2f9ea510b0c.png"
                />
                <div className="limit-empty-text">暂无可关联的活动</div>
              </div>
            )}
          </div>
        </Modal>
      </Container>
    </div>
  );
};

export default ActivityOperate;
